export const RequiredInput = () => <span className="text-danger ps-1">*</span>;
